import React, { Component } from "react";
import RestaurantIcon from "@material-ui/icons/Restaurant";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxIcon from "@material-ui/icons/CheckBoxOutlined";
import walletImage from "../assets/wallet.png";

import { connect } from "react-redux";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

export class UseCustomerWallet extends Component {
  render() {
    const {
      language,
      themeColor,
      setUserCustomerWallet,
      useCustomerWallet,
      settings,
      user,
    } = this.props;
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        style={{
          marginTop: 30,
        }}
      >
        <p
          className="box-title"
          style={{
            textAlign: language === "arabic" ? "right" : "left",
          }}
        >
          {language === "arabic" ? "إستخدام المحفظة" : "Use wallet"}
        </p>
        <div
          className="border-top border-bottom w-100 mx-0 mb-3 py-4"
          style={{
            backgroundColor: "white",
            display: "flex",
            padding: 15,
            justifyContent: "space-between",
            direction: language === "arabic" ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={walletImage}
              style={{
                marginRight: language === "arabic" ? 0 : 15,
                marginLeft: language === "arabic" ? 15 : 0,
                width: 30,
              }}
            />
            <span
              style={{
                textDecoration: user.wallet <= 0 && "line-through",
              }}
            >
              {language === "arabic"
                ? "إستخدام الرصيد من محفظتك"
                : "Use credits from your wallet"}
            </span>
            <span
              className={"mx-2".concat(
                currencyIcon
              )}
              style={{ fontSize: 12 }}
            >
              (
              {`${user.wallet.toFixed(settings?.currency_decimals)}
                ${
                  language == "english"
                    ? settings?.currency_english
                    : settings?.currency_local
                }`}
              )
            </span>
          </div>
          <Checkbox
            disabled={user.wallet <= 0}
            checkedIcon={<CheckBoxIcon style={{ color: themeColor }} />}
            checked={useCustomerWallet}
            onChange={setUserCustomerWallet}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.store.language,
  themeColor: state.store.store.settings.dark || "#0099cc",
  settings: state.store.store.settings,
  user: state.auth.user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UseCustomerWallet);
